import React from 'react';
import LearnMoreTile, { ILearnMoreTile } from '../LearnMoreTile/LearnMoreTile';
import { useVisitId } from '../../hooks/useVisitId';
import useContextToken from '../../hooks/useContextToken';

import Star from '../../svgs/star-f.svg';
import TV from '../../svgs/tv-f.svg';
import GuideNav from '../../svgs/guide-nav.svg';
import MobileF from '../../svgs/mobile-f.svg';
import Mobile from '../../svgs/mobile.svg';

import './LearnMore.scss';

const tiles: ILearnMoreTile[] = [
  {
    icon: <Star className="learn-more-tile__icon" />,
    title: 'Quick Start Guide',
    text: 'Create your account, manage preferences and get the most out of your services',
    linkPath: 'https://www.spectrum.net/page/welcome-spectrum/?cid=van-hlp-ica',
  },
  {
    icon: <Mobile className="learn-more-tile__icon" />,
    title: 'Spectrum Access',
    text: 'Audio and video accessibility solutions for your mobile devices',
    linkPath: 'https://www.spectrum.net/page/accessibility/',
  },
  {
    icon: <TV className="learn-more-tile__icon" />,
    title: 'Channel Lineup',
    text: 'View all channels included in your plan',
    linkPath: 'https://www.spectrum.net/channel-lineup',
  },
  {
    icon: <GuideNav className="learn-more-tile__icon" />,
    title: 'Using the Guide',
    text: 'Browse live and future listings, guide options and more',
    linkPath: 'https://www.spectrum.net/support/tv/spectrum-guide-overview/',
  },
  {
    icon: <MobileF className="learn-more-tile__icon" />,
    title: 'My Spectrum App',
    text: 'Pay your bill, manage your Spectrum account and more',
    linkPath: 'https://www.spectrum.net/page/my-spectrum-app',
  },
];

const LearnMore = ({ ipOnly }) => {
  const tileList = ipOnly
    ? tiles.filter((t) => t.title !== 'Using the Guide')
    : tiles.filter((t) => t.title !== 'Spectrum Access');

  const visitId = useVisitId();
  const { contextToken } = useContextToken();

  // Checks linkPath for query parameters and adds the visitId
  const checkLinkPath = (url) => {
    if (url.includes('spectrum.com') || url.includes('spectrum.net')) {
      const currentUrl = new URL(url);
      const params = new URLSearchParams(currentUrl.search);

      if (visitId) {
        params.set('visitId', visitId);
      }

      return `${currentUrl.origin}${currentUrl.pathname}?${params.toString()}${contextToken}`;
    }

    return url;
  };

  const tileListWithVisitIds = tileList.map((tile) => {
    return {
      ...tile,
      linkPath: checkLinkPath(tile.linkPath),
    };
  });

  return (
    <section className="learn-more">
      <div className="learn-more__content">
        <h2>Learn More About Setting Up Your Experience</h2>
        <ul className="learn-more__tiles">
          {tileListWithVisitIds.map((tile) => (
            <li key={tile.title}>
              <LearnMoreTile tile={tile} />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default LearnMore;
